export const COLUMNS = [
  { id: "c_year", label: "Cal Year", align: "left" },
  { id: "c_month", label: "Month", align: "left" },
  { id: "meter_id", label: "Meter ID", align: "left" },
  {
    id: "assoc_permit_groups",
    label: "Permit Owner/Group",
    align: "left",
    minWidth: 160,
    maxWidth: 220,
  },
  {
    id: "assoc_wells",
    label: "Wells",
    align: "left",
    minWidth: 140,
    maxWidth: 200,
  },
  {
    id: "assoc_permits",
    label: "Permits",
    align: "left",
    minWidth: 160,
    maxWidth: 240,
  },
  { id: "prev_meter_reading", label: "Last Rdg", align: "right" },
  { id: "meter_reading", label: "Reading", align: "right" },
  { id: "adjustment", label: "Adj", align: "right" },
  {
    id: "mr_adjustment_reason_ndx",
    label: "Adj Reason",
    align: "left",
  },
  {
    id: "mr_report_status_ndx",
    label: "Status",
    align: "left",
    minWidth: 100,
  },
  { id: "calculated_gallons", label: "Calc Gallons", align: "right" },
  { id: "notes", label: "Notes", align: "left", minWidth: 200 },
];

export const COLUMN_FILTER_CONFIG = {
  c_year: { key: "calendarYears", label: "Cal Year" },
  c_month: { key: "calendarMonths", label: "Month" },
  meter_id: { key: "meterIds", label: "Meter ID" },
  assoc_permit_groups: { key: "permitGroups", label: "Permit Owner/Group" },
  assoc_wells: { key: "wells", label: "Wells" },
  assoc_permits: { key: "permits", label: "Permits" },
  mr_report_status_ndx: { key: "reportStatuses", label: "Status" },
};

export const COMPACT_HIDDEN_COLUMNS = new Set([
  "assoc_permit_groups",
  "assoc_wells",
  "assoc_permits",
]);

export const EMPTY_TOKEN = "<empty>";

export const DEFAULT_COLUMN_FILTERS = {
  calendarYears: [],
  calendarMonths: [],
  meterIds: [],
  permitGroups: [],
  wells: [],
  permits: [],
  reportStatuses: [],
};
